export const calculateAmount = (count: string, price: string) => (parseFloat(count) * parseFloat(price)).toFixed(2);